import { useState } from "react";

const EditTask = ({ todo, index, handleEditTask }) => {
  const [btnStart, setBtnStart] = useState("btn btn-primary m-2");
  return (
    <div>
      <button
        className={btnStart}
        onClick={() => {
          handleEditTask(index);

          btnStart
            ? setBtnStart("btn btn-success m-2")
            : setBtnStart("btn btn-success m-2");
        }}
      >
        {todo.completed ? "Done" : "Complete Task"}
      </button>
    </div>
  );
};

export default EditTask;
